import { useQuery } from "@tanstack/react-query";
import { getJobs, JobsResponseDTO } from "api/jobs";
import { QUERY_KEYS } from "consts";

export const useJobs = (size: number, page: number) => useQuery<JobsResponseDTO>([QUERY_KEYS.JOBS, size, page], () => getJobs(size, page));
